import { Button, CardHeader, Paper, Tab, Tabs, Typography, } from "@mui/material";
import { withStyles } from "@mui/styles";
import axios from "axios";
import * as React from "react";
import * as uuid from "uuid";

import { LoadingWrapper } from "../../../components/LoadingWrapper";
import { Config } from "../../../config/config";
import { Helpers } from "../../../utils/helpers";
import { PopupMessage } from "../../../utils/message";
import { TabPanel } from "../../Player";
import { IAPItem } from "../IAPs";
import { GoldPacks } from "./GoldPacks";
import { GoldPackItem } from "./GoldPacks/entry";
import { OfferPackItem, OfferPacks } from "./OfferPacks";
import { RotationPacks } from "./RotationPacks";
import { RotationPackItem } from "./RotationPacks/entry";
import { ValueBundles } from "./ValueBundles";
import { ValueBundleItem } from "./ValueBundles/entry";

interface PackProps {
    activeUser: any;
    activeEnv: any;
    classes: any;
}

interface PackState {
    list: {
        offerPacks: any[];
        shopPacks: ValueBundleItem[];
        goldPacks: GoldPackItem[];
        rotationPacks: RotationPackItem[];
    };

    loading: boolean;
    activeTab: string;
}

export class ShopPacksWrapped extends React.Component<PackProps, PackState> {
    list = {
        offerPacks: [],
        shopPacks: [],
        goldPacks: [],
        rotationPacks: []
    };

    saving = false;

    static iaps: IAPItem[] = [];

    constructor(props: PackProps) {
        super(props);

        this.state = {
            list: {
                offerPacks: [],
                shopPacks: [],
                goldPacks: [],
                rotationPacks: []
            },
            loading: true,
            activeTab: "offerPacks"
        };

        document.title = "Mavia | Shop Packs";
    }

    static iapsByPlatform(platform: string | string[]) {
        if (typeof platform === "string") {
            platform = [platform];
        }

        return ShopPacksWrapped.iaps.filter(item => platform.includes(item.platform));
    }

    componentDidMount() {
        this.fetch();
    }

    fetch = () => {
        axios.get(`${Config.getInstance.apiUrl}/api/shop/packs`, {
            headers: {
                Authorization: Helpers.getSessionId(),
                env: this.props.activeEnv,
            }
        }).then(response => {
            this.setState({
                loading: false,
                list: response.data.packs
            });

            this.list = {...response.data.packs};
            ShopPacksWrapped.iaps = response.data.iaps;
        });
    };

    save = async () => {
        if (this.saving) {
            return;
        }

        this.saving = true;

        try {
            await axios.post(`${Config.getInstance.apiUrl}/api/shop/packs`, {
                packs: this.list
            }, {
                headers: {
                    Authorization: Helpers.getSessionId(),
                    env: this.props.activeEnv,
                }
            });

            PopupMessage.success("Shop Packs successfully saved");
        } catch (e) {
            console.error(e);

            PopupMessage.error("Something went wrong");
        }

        this.saving = false;
    };

    addGoldPack = () => {
        this.list.goldPacks.push({
            id: uuid.v4(),
            packageId: "",
            gold: 0,
            slotIndex: 0,
            googleId: "",
            appleId: "",
            samsungId: "",
            huaweiId: ""
        });

        this.setState({
            list: {...this.list}
        });
    };

    updateGoldPack = (item: GoldPackItem) => {
        const index = this.list.goldPacks.findIndex(_item => _item.id === item.id);

        if (index < 0) {
            return;
        }

        this.list.goldPacks[index] = item;
    };

    removeGoldPack = (item: GoldPackItem) => {
        const index = this.list.goldPacks.findIndex(_item => _item.id === item.id);

        this.list.goldPacks.splice(index, 1);

        this.setState({
            list: {...this.list}
        });
    };

    addValueBundle = () => {
        this.list.shopPacks.push({
            id: uuid.v4(),
            title: "",
            subtitle: "",
            packageId: "",
            googleId: "",
            appleId: "",
            samsungId: "",
            huaweiId: "",
            category: "gunsmith",
            quantity: 1,
            availableEndOf: "week",
            bonusValue: 0,
            validatePayment: true,
            items: []
        });

        this.setState({
            list: {...this.list}
        });
    };

    updateValueBundle = (item: ValueBundleItem) => {
        const index = this.list.shopPacks.findIndex(_item => _item.id === item.id);

        if (index < 0) {
            return;
        }

        this.list.shopPacks[index] = item;
    };

    removeValueBundle = (item: ValueBundleItem) => {
        const index = this.list.shopPacks.findIndex(_item => _item.id === item.id);

        this.list.shopPacks.splice(index, 1);

        this.setState({
            list: {...this.list}
        });
    };

    addRotationPack = () => {
        this.list.rotationPacks.push({
            id: uuid.v4(),
            title: "",
            subtitle: "",
            packageId: "",
            googleId: "",
            appleId: "",
            samsungId: "",
            huaweiId: "",
            category: "special",
            quantity: 1,
            endOf: "week",
            bonusValue: 0,
            validatePayment: true,
            items: []
        });

        this.setState({
            list: {...this.list}
        });
    };

    updateRotationPack = (item: RotationPackItem) => {
        const index = this.list.rotationPacks.findIndex(_item => _item.id === item.id);

        if (index < 0) {
            return;
        }

        this.list.rotationPacks[index] = item;
    };

    removeRotationPack = (item: RotationPackItem) => {
        const index = this.list.rotationPacks.findIndex(_item => _item.id === item.id);

        this.list.rotationPacks.splice(index, 1);

        this.setState({
            list: {...this.list}
        });
    };

    updateOfferPacks = (packs: OfferPackItem[]) => {
        this.list.offerPacks = packs;

        this.setState({
            list: {...this.list}
        });
    };

    onTabChange = (_event, tab: string) => {
        this.setState({
            activeTab: tab
        });
    };

    render() {
        return <div className="contentPadding-full" style={{ marginTop: 24 }}>
            <Paper elevation={0} style={{ marginBottom: 20 }}>
                <CardHeader title="Shop"/>

                <div style={{width: "100%"}}>
                    <div style={{padding: "0 24px"}}>
                        <div className={this.props.classes.tabsRoot}>
                            <Tabs value={this.state.activeTab} onChange={this.onTabChange} style={{marginTop: 25}}>
                                <Tab style={{minWidth: 120}} value={"offerPacks"}
                                    label={"Offer Packs"} {...Helpers.a11yProps("offerPacks")} />
                                <Tab style={{minWidth: 120}} value={"shopPacks"}
                                    label={"Value Bundles"} {...Helpers.a11yProps("shopPacks")} />
                                <Tab style={{minWidth: 120}} value={"goldPacks"}
                                    label={"Gem Packs"} {...Helpers.a11yProps("goldPacks")} />
                                <Tab style={{minWidth: 120}} value={"rotationPacks"}
                                    label={"Rotation Packs"} {...Helpers.a11yProps("rotationPacks")} />
                            </Tabs>
                        </div>
                    </div>

                    {this.state.loading && <div style={{ padding: 24 }}>
                        {Helpers.renderSkeletonRows(5, 50)}
                    </div>}

                    {!this.state.loading && <div>
                        <TabPanel value={this.state.activeTab} index={"offerPacks"}>
                            <OfferPacks list={this.state.list.offerPacks} classes={this.props.classes}
                                        onChange={this.updateOfferPacks}/>
                        </TabPanel>

                        <TabPanel value={this.state.activeTab} index={"shopPacks"}>
                            <ValueBundles list={this.state.list.shopPacks} classes={this.props.classes}
                                        onAdd={this.addValueBundle} onUpdate={this.updateValueBundle}
                                        onRemove={this.removeValueBundle}/>
                        </TabPanel>

                        <TabPanel value={this.state.activeTab} index={"goldPacks"}>
                            <GoldPacks list={this.state.list.goldPacks} classes={this.props.classes}
                                    onAdd={this.addGoldPack} onUpdate={this.updateGoldPack}
                                    onRemove={this.removeGoldPack}/>
                        </TabPanel>

                        <TabPanel value={this.state.activeTab} index={"rotationPacks"}>
                            <RotationPacks list={this.state.list.rotationPacks} classes={this.props.classes}
                                        onAdd={this.addRotationPack} onUpdate={this.updateRotationPack}
                                        onRemove={this.removeRotationPack}/>
                        </TabPanel>
                    </div>}
                </div>

                {!this.state.loading && <div style={{padding: 24, width: "100%"}}>
                    <Button disableElevation variant={"contained"} color={"primary"} onClick={this.save}>
                        Save
                    </Button>
                </div>}
            </Paper>
        </div>;
    }
}

const styles: any = (theme: any) => ({
    tabsRoot: {
        borderBottom: "1px solid #d8d8d8",
    },
});

export const ShopPacks = withStyles(styles)(ShopPacksWrapped);
